import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'; /* for date selector */
import SelectDropDown from '../../components/common/SelectDropDown';
import ResizeThrottler from 'APP_ROOT/components/ResizeThrottler';
import { strings, getCurrentLocale } from '../../localization';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize'; // "to continue using CSS stylesheets and classes" https://github.com/airbnb/react-dates
import { DATE_DISPLAY_OPTIONS } from './Constants';
import { connect } from 'react-redux';
import { ACTIONS as dispatchActions, ACTIVE_MENU_ITEM_IDS } from '../../data/layoutTemplateModularFullscreen/duck';
import TagPermissions from '../../components/common/tagsPermissions';
const RESIZE_EVENT_HANDLER_THROTTLE_INTERVAL_MS = 100; // IMPORTANT: must be a greater value than RESIZE_EVENT_DISPATCH_INTERVAL_MS (togglePanels(...) triggers resize event directly)

const MAX_WIDTH_FOR_DATE_SELECTOR = 576;
export class ReviewHeader extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            windowWidth: window.innerWidth,
            dateFocusedInput: undefined,
            shouldShowReportDescription: false,
        }
    }

    componentDidUpdate() {
        if(!this.state.shouldShowReportDescription){
            if(this.props.executeQuery){
                this.setState({shouldShowReportDescription: true});
            }
        }
    }

    resizeCallback = () => {
        this.setState({ windowWidth: window.innerWidth });
    }

    checkDateIsOutside = (day) => {
        return false;
    }

    onClickOpenFilter = () => {
        this.props.setMainModuleGroupNavigation(false); // open filter panel
    }

    isUserAnAdmin = () => {
        return this.props.user && this.props.user.currentAccount && this.props.user.currentAccount.role === 'Admin';
    }

    render() {
        const selectedDate = DATE_DISPLAY_OPTIONS[this.props.selectedDateIndex];
        const currentLocale = getCurrentLocale();
        const isUserAnAdmin = this.isUserAnAdmin();

        let reportsTitle = strings.reports_raven_reports_title;
        switch (this.props.match.params.parentGroupingType) {
            case "events":
                reportsTitle = strings.event_review;
                break;
            default:
                break;
        }

        return (
            <div className="review-header">
                <div className="review-header-col">
                    <div className="header-title-wrapper">
                        <h1 className="d-inline-block">{reportsTitle}</h1>
                        {/* <div className="role-permission-level-wrapper">
                            <i className="material-icons">info</i>
                            <div className="role-permission-level">{isUserAnAdmin ? strings.reports_raven_admin_access : strings.reports_raven_guest_access}</div>
                        </div> */}
                    </div>
                    <p className="review-report-description">
                        {this.state.shouldShowReportDescription ?
                            this.props.allEventTypesSelected ? strings.formatString(strings.reports_raven_reports_description, strings.reports_raven_reports_any_description, selectedDate.label) : strings.formatString(strings.reports_raven_reports_description, strings.reports_raven_reports_custom_description, selectedDate.label)
                            : 
                            <>{strings.reports_raven_reports_instructions} <button className="btn-link" onClick={this.onClickOpenFilter}>{strings.reports_raven_reports_instructions_link}</button></>
                        }
                    </p>
                </div>
                <div className="review-header-col options">
                    <div className="filter-col">
                        <button className="btn" onClick={this.onClickOpenFilter}>{strings.event_review_all_filter_options}</button>
                    </div>
                </div>
            </div>
        )
    }
}

ReviewHeader.propTypes = {
    setMainModuleGroupNavigation: PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setMainModuleGroupNavigation: (isCollapsed) => {
            dispatch(dispatchActions.setMainModuleGroupNavigation(isCollapsed));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewHeader);